module.exports = __webpack_public_path__ + "img/concrete-hole-decal-19.db73193e.png";